import { Component } from '@angular/core';

@Component({
  selector: 'app-ru-tos-contents',
  templateUrl: './ru-tos-contents.component.html',
})
export class RussianTOSContentsComponent {}
